import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { RouteProps } from 'react-router-dom';

import { RouteConfig } from './index';
import { fromLayout, useAppDispatch } from '../store';

const DEFAULT_PAGE_TITLE = 'app.page.title';

export type RouteWithPageTitleProps = RouteProps & {
  pageTitle?: RouteConfig['pageTitle'];
  showSidebar?: RouteConfig['showSidebar'];
  showNavbar?: RouteConfig['showNavbar'];
};

const RouteWithPageTitle = (props: RouteWithPageTitleProps) => {
  const { pageTitle, element, showSidebar, showNavbar } = props;
  const intl = useIntl();
  const dispatch = useAppDispatch();

  useEffect(() => {
    document.title = intl.formatMessage({ id: pageTitle || DEFAULT_PAGE_TITLE });
    dispatch(fromLayout.setShowSideBar(showSidebar ?? true));
    dispatch(fromLayout.setShowNavBar(showNavbar ?? true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // set only once
  return <>{element}</>;
};

export default RouteWithPageTitle;
